<div *ngIf="messages?.length > 0" class="wrapper">
    <ng-container *ngFor="let message of messages; let i = index;">
        <div *ngIf="i === (currentIndex | async)" @message class="message" [class.multi-message]="messages?.length > 1">
            <span class="text-message" [title]="message">{{message}}</span>
        </div>
    </ng-container>
    
    <div *ngIf="messages?.length > 1" class="bullets">
        <div
            *ngFor="let message of messages; let i = index;"
            (click)="setIndex(i)"
            class="bullet" [class.active]="i === (currentIndex | async)"
        ></div>
    </div>
</div>